import { InMemoryCacheConfig } from '@apollo/client';
import { mergeOpeningPaginatedResults } from './mergeOpeningPaginatedResults';

export const typePolicies: InMemoryCacheConfig['typePolicies'] = {
  EnterprisePlanType: {
    merge: true,
  },
  OpeningType: {
    fields: {
      paidAddons: {
        merge (_existing, incoming) {
          return incoming;
        },
      },
    },
  },
  Query: {
    fields: {
      openings: {
        keyArgs: ['searchTags'],
        merge: mergeOpeningPaginatedResults,
      },
    },
  },
  SubscriptionPlanType: {
    merge: true,
  },
  UserProfileType: {
    merge: true,
  },
  VerifiedUserType: {
    keyFields: ['user', ['id']],
  },
};
